import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { TuiHint, TuiIcon, TuiCheckbox, TuiInput } from '@taiga-ui/core';
import { TuiTooltip } from '@taiga-ui/kit';
import { WorkflowFormFieldInputCheckbox } from '@features/requests/request-form/components/request-form-workflows/types';

@Component({
  selector: 'x-input-checkbox-field',
  imports: [
    ReactiveFormsModule,
    TuiHint,
    TuiCheckbox,
    TuiInput,
    TuiTooltip,
    TuiIcon,
  ],
  templateUrl: './input-checkbox-field.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InputCheckboxFieldComponent {
  field = input.required<WorkflowFormFieldInputCheckbox>();
  control = input.required<FormControl<boolean>>();
}
